/* tslint:disable */
/* eslint-disable */
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { GlobalEnumsAceDokumentenart as AceXFoundPortalCoreEntitiesGlobalEnumsAceDokumentenart } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-dokumentenart';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IDocumenttypeDisplayModel {
  allowMultiUpload?: boolean;
  documenttypeId?: string;
  dokumentenart?: AceXFoundPortalCoreEntitiesGlobalEnumsAceDokumentenart;
  erlaubteDateiendungen?: null | Array<string>;
  hasVorlage?: boolean;
  herkunftsnachweis?: null | boolean;
  infotext?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  isUploadRequired?: boolean;
  maxAnzahlDerAnlagen?: null | number;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  rechtsformen?: null | Array<number>;
  sectionId?: null | string;
}
export class DocumenttypeDisplayModel extends BaseModel implements IDocumenttypeDisplayModel {
  allowMultiUpload?: boolean;
  documenttypeId?: string;
  dokumentenart?: AceXFoundPortalCoreEntitiesGlobalEnumsAceDokumentenart;
  erlaubteDateiendungen?: null | Array<string>;
  hasVorlage?: boolean;
  herkunftsnachweis?: null | boolean;
  infotext?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  isUploadRequired?: boolean;
  maxAnzahlDerAnlagen?: null | number;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  rechtsformen?: null | Array<number>;
  sectionId?: null | string;
}
class BaseDocumenttypeDisplayModelFormGroup extends FormGroup {
  private static _instance: DocumenttypeDisplayModelFormGroup;
  
  public static get Instance(): DocumenttypeDisplayModelFormGroup {
    this._instance = new DocumenttypeDisplayModelFormGroup({
      allowMultiUpload: new FormControl(null),
      documenttypeId: new FormControl(null),
      dokumentenart: new FormControl(null),
      erlaubteDateiendungen: new FormArray([]),
      hasVorlage: new FormControl(null),
      herkunftsnachweis: new FormControl(null),
      infotext: new FormArray([]),
      isUploadRequired: new FormControl(null),
      maxAnzahlDerAnlagen: new FormControl(null),
      name: new FormArray([]),
      rechtsformen: new FormArray([]),
      sectionId: new FormControl(null),
    });

    return this._instance;
  }
}


export class DocumenttypeDisplayModelFormGroup extends BaseDocumenttypeDisplayModelFormGroup {
  public get AllowMultiUpload(): FormControl {
    return this.controls["allowMultiUpload"] as FormControl;
  }
  public get DocumenttypeId(): FormControl {
    return this.controls["documenttypeId"] as FormControl;
  }
  public get Dokumentenart(): FormControl {
    return this.controls["dokumentenart"] as FormControl;
  }
  public get ErlaubteDateiendungen(): FormArray<FormControl<null> | FormControl<string>> {
    return this.controls["erlaubteDateiendungen"] as FormArray<FormControl<null> | FormControl<string>>;
  }
  public get HasVorlage(): FormControl {
    return this.controls["hasVorlage"] as FormControl;
  }
  public get Herkunftsnachweis(): FormControl {
    return this.controls["herkunftsnachweis"] as FormControl;
  }
  public get Infotext(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotext"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get IsUploadRequired(): FormControl {
    return this.controls["isUploadRequired"] as FormControl;
  }
  public get MaxAnzahlDerAnlagen(): FormControl {
    return this.controls["maxAnzahlDerAnlagen"] as FormControl;
  }
  public get Name(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["name"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Rechtsformen(): FormArray<FormControl<null> | FormControl<number>> {
    return this.controls["rechtsformen"] as FormArray<FormControl<null> | FormControl<number>>;
  }
  public get SectionId(): FormControl {
    return this.controls["sectionId"] as FormControl;
  }
  

}

export module DocumenttypeDisplayModelForm
  {
    export class FormFields
    {
      static _allowMultiUpload: string = "allowMultiUpload";
      static _documenttypeId: string = "documenttypeId";
      static _dokumentenart: string = "dokumentenart";
      static _erlaubteDateiendungen: string = "erlaubteDateiendungen";
      static _hasVorlage: string = "hasVorlage";
      static _herkunftsnachweis: string = "herkunftsnachweis";
      static _infotext: string = "infotext";
      static _isUploadRequired: string = "isUploadRequired";
      static _maxAnzahlDerAnlagen: string = "maxAnzahlDerAnlagen";
      static _name: string = "name";
      static _rechtsformen: string = "rechtsformen";
      static _sectionId: string = "sectionId";
    }
  }

